import { Component, OnInit, ViewChild } from '@angular/core';
import { isBs3 } from 'ngx-bootstrap/utils';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ModalDirective } from 'ngx-bootstrap/modal';
// import { Module } from 'ag-grid-community';
import { Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { ConstantService } from '../../../services/constant.service';
import { Router } from '@angular/router';
import { ViewRendererComponent } from '../../../renderer/view-renderer.component';
import { ApiService } from '../../../services/api.service';
import { GrievanceService } from '../../../services/grievance.services';
import { EditButtonRendererComponent } from '../../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../../renderer/delete-button-renderer.component';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import { ExcelService } from '../../../services/export-excel.service';

@Component({
  selector: 'app-monthly-attendance',
  templateUrl: './monthly-attendance.component.html'
})
export class MonthlyAttendanceComponent implements OnInit {
  @ViewChild('deleteComplainModal') public deleteComplainModal: ModalDirective;
  @ViewChild('deleteBulkComplainModal') public deleteBulkComplainModal: ModalDirective;
  @ViewChild('updateComplaintModal') public updateComplaintModal: ModalDirective;
  isBs3 = isBs3();
  public gridApi;
  public gridColumnApi;
  public gridOptions;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  public permission;
  public rowClassRules;
  public rowSelection;
  _ = _;
  moment = moment;
  selectedYear = moment().format('YYYY');
  selectedMonth = moment().format('MM');
  
  dropdownList = [];
  selectedUser: any = {};
  dropdownSettings: IDropdownSettings = {};
  filterParams = {
    dateRange: [new Date(), new Date()],
    date: new Date(),
    project: '', 
    punch_slot: '',
    username: '',
    month: moment().format('MM'),
    year: moment().format('YYYY')
  }

  bsRangeValue: Date[];
  paginaton = {
    totalItems: 0,
    currentPage: 1,
    maxSize: 100,
  }

  years = [moment().format('YYYY'), moment().subtract(1, 'years').format('YYYY')];
  months = this.constantService.MONTHS;
  
  alert = {
    type: 'info',
    msg: '',
    timeout: 3000
  }
  maxDate = new Date();

  exportAsConfig: ExportAsConfig = {
  type: 'pdf', // the type you want to download
  elementIdOrContent: 'tableToPrint', // the id of html/table element,
  options: { // html-docx-js document options
    
    jsPDF: {
       orientation: 'landscape',
    },
    margins: {
     top: '40px',
     bottom: '40px',
     left: '40px',
     right: '40px'
   }
    
  }
}

username = '';
  selectedComplaint : any = {};

  exportingCsv = false;
  constructor(private constantService: ConstantService, private apiService: ApiService, private grievanceService: GrievanceService,
    public router: Router, private exportAsService: ExportAsService, private excelService: ExcelService) {
    this.permission = this.constantService.getCookies().PERMISSION;
    let permissionArray = this.permission.split('');
    this.username = this.constantService.getCookies().USERNAME;

    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: false,
      resizable: true,
      floatingFilter: false,
      filterParams: { buttons: ['clear'] }
    };

    this.frameworkComponents = {
      viewRenderer: ViewRendererComponent,
      editButtonRenderer: EditButtonRendererComponent,
      deleteButtonRenderer : DeleteButtonRendererComponent
    };
    
    this.rowSelection = 'multiple';
    this.columnDefs = [];
    this.generateColDefs();
    
      console.log(this.columnDefs)
    
  }

  generateColDefs() {
    this.columnDefs = [
      // { headerName: '', field: 'value', cellRenderer: 'viewRenderer', colId: 'params1', width: 100, filter: false, resizable: false, floatingFilter: false, sortable: false, pinned: 'left', cellClass: ['text-center'] },
      { headerName: 'Employee Id', field: 'employee_id', width: 100},
      { headerName: 'Full Name', field: 'full_name', width: 150 },
      { headerName: 'Date Of Joining', field: 'date_of_joining', width: 100 },
      { headerName: 'Location', field: 'location', width: 150 },
      { headerName: 'Department', field: 'department', width: 150 },
      { headerName: 'Designation', field: 'designation', width: 100 }];
      _.each(this.generateMonthDate(), (date)=> {
        this.columnDefs.push({ headerName: moment(date).format('DD-MMM'), field: date, width: 90},)
      })
      this.columnDefs.push(
        { headerName: 'Present', field: 'present', width: 80 },
        { headerName: 'Absent', field: 'absent', width: 80 },
        { headerName: 'Total Weekly Offs', field: 'total_weekly_Offs', width: 100 }
      )
  }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    console.log(this.grievanceService.getSelectedDateRange());
    if (this.grievanceService.getSelectedDateRange().length > 0) {
      this.filterParams.dateRange = this.grievanceService.getSelectedDateRange();
    }
    this.getResources();
  }
  records = [];
  paginatedRecord = [];
  allUserMonthlyAttend; any = [];

  monthData: any = {
    working_days: moment('"' + this.filterParams.year + "-" + this.filterParams.month, "YYYY-MM").daysInMonth(),
    total_days: moment('"' + this.filterParams.year + "-" + this.filterParams.month, "YYYY-MM").daysInMonth()
  };
  
  
  allUserAttend = [];
  searchFullMonthAttendance() {
    this.allUserAttend = [];
    this.records = [];
    
    this.generateColDefs();
    let queryString = "attendance.*, project.name as project_name FROM attendance, project WHERE MONTH(attendance.date) = '" + this.filterParams.month + "' AND YEAR(attendance.date) = '" + this.filterParams.year + "'";
    if(this.filterParams.username) queryString += " AND attendance.username LIKE '" + this.filterParams.username + "'"; 
    if(this.filterParams.project) queryString += " AND attendance.project LIKE '" + this.filterParams.project + "'"; 
    queryString += " AND attendance.project = project.srl_no ORDER BY srl_no DESC"; 
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      // console.log(resp);
      let totalAttendance = resp;
      let dateArray = this.generateMonthDate();
      // console.log(dateArray);
      _.each(this.userList, (user) => {
        let pCount = 0;
        let aCount = 0;
        let WOCount = 0;
        let sortedDetail = {
          employee_id: user.employee_id,
          phone_no: user.phone_no,
          full_name: user.full_name,
          date_of_joining: user.date_of_joining,
          location: user.work_location,
          department: user.work_location,
          designation: user.designation,
        }
        _.each(dateArray, (date) => {
          // console.log(date)
          let attendance = _.filter(totalAttendance, (attend) => {
            return user.phone_no === attend.username && date === moment(attend.date).format('YYYY-MM-DD');
          })
          sortedDetail[date] =  attendance.length > 0 ? 'P' : 'A';
          if(attendance.length > 0) {
            if(moment(date).format('ddd') === 'Sun') {
              sortedDetail[date] = 'P/WO';
            } else {
              sortedDetail[date] = 'P';
            }
            pCount++;
          } else {
            if(moment(date).format('ddd') === 'Sun') {
              sortedDetail[date] = 'WO';
            } else {
              sortedDetail[date] = 'A';
            }
            aCount++;
          }
          if(moment(date).format('ddd') === 'Sun') {
            WOCount++;
          }
        })
        sortedDetail['present'] = pCount;
        sortedDetail['absent'] = aCount;
        sortedDetail['total_weekly_Offs'] = WOCount;
        this.allUserAttend.push(sortedDetail);
      })
      
      // console.log(this.allUserAttend)
      this.records = this.allUserAttend;
      this.arrangeDataForExport(this.records);
    })
  }

  generateMonthDate() {
    let dates = [];
    if(this.filterParams.month === moment().format('MM')){
      let dt = parseInt(moment().format('DD'));
      var array = _.range(1, dt+1); 
      _.each(array, (d) => {
        let dt = `${d}`.padStart(2, "0");
        dates.push(`${this.filterParams.year}-${this.filterParams.month}-${dt}`);
      })
    } else {
      let daysInMonth = moment(`${this.filterParams.year}-${this.filterParams.month}`, "YYYY-MM").daysInMonth();
      var array = _.range(1, daysInMonth+1); 
      _.each(array, (d) => {
        let dt = `${d}`.padStart(2, "0");

        dates.push(`${this.filterParams.year}-${this.filterParams.month}-${dt}`);
      })
    }
    return dates;
  }


  pageChanged(event): void {
    this.paginaton.currentPage = event.page;
    this.paginatedRecord = this.records.slice((this.paginaton.currentPage - 1) * this.paginaton.maxSize, this.paginaton.currentPage * this.paginaton.maxSize);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  // selectedGrievance: any = {};
  // selectedUser: any = {};
  // updateComplainForm: any = {};
  // methodFromParent(userData) {
  //   this.selectedUser = userData;
  //   this.selectedComplaint = userData;
  //   console.log(this.selectedUser, userData.action);
  //   if(userData.action === 'edit') {
  //     this.updateComplainForm = _.clone(this.selectedUser);
  //     this.updateComplaintModal.show();
  //   }
  //   if(userData.action === 'delete') {
  //     this.deleteComplainModal.show();
  //   }
  // }

  onBtnExport() {
    var params = this.getParams();
    if (params.suppressQuotes || params.columnSeparator) {
      alert(
        'NOTE: you are downloading a file with non-standard quotes or separators - it may not render correctly in Excel.'
      );
    }
    this.gridApi.exportDataAsCsv(params);
    setTimeout(() => {
      this.exportingCsv = false;
    }, 2000)
  }

  getParams() {

    let reportDate = "Complain List " + moment(this.filterParams.dateRange[0]).startOf('day').format('YYYY-MM-DD') + " to " + moment(this.filterParams.dateRange[1]).endOf('day').format('YYYY-MM-DD');
    return {
      suppressQuotes: '',
      columnSeparator: '',
      customHeader: reportDate,
      customFooter: '',
      fileName: 'Complain_List_'+ moment(this.filterParams.dateRange[0]).format('YYYY-MM-DD') + "_to_" + moment(this.filterParams.dateRange[1]).endOf('day').format('YYYY-MM-DD')
    };
  }


  userList: any = [];
  projectList: any = [];
  userObj: any = {};
  getResources() {
    let getUser = this.apiService.getData('employees');
    let getProject = this.apiService.getData('project');
    let that = this;
    Promise.all([getUser, getProject]).then((resp) => {
      that.userList = resp[0];
      _.each(that.userList, (user) => {
        that.userObj[user.phone_no] = user;
      })
      that.projectList = resp[1];
      this.searchFullMonthAttendance();
    })
  }

  punch_slot: any = [];
  projectUsers: any = [];
  selectProject(project) {
    console.log(project);
    let projectMatch = _.filter(this.projectList, {'name': project});
    console.log(projectMatch);
    if(projectMatch.length > 0 &&  projectMatch[0].name) {
      if(projectMatch[0].punch_slot) {
        let slot = (projectMatch[0].punch_slot).split(',');
        this.punch_slot = slot;
      }
      
      this.projectUsers = _.filter(this.userList, (user: any) => {
        return user.project === projectMatch[0].name;
      })
      console.log(this.projectUsers);
    }
    
  }

  
  exportPdf() {
    this.exportAsService.save(this.exportAsConfig, 'Complain_Report').subscribe(() => {
      
    });
  }
  
  onItemSelect(e) {
  }
  onItemDeSelect(e) {
  }
  onSelectAll(e){
    
  }

  excelExportData: any = [];

  ClickExport(): void {
    let complainDate = "";
      complainDate = `Monthly Attendance Register [ ${this.filterParams.month} - ${this.filterParams.year}]`;    
    let fileData = {
      fileName: `Monthly_Attendance_Register_${this.filterParams.month}_${this.filterParams.year}`,
      reportDate: moment().format('YYYY-MM-DD'),
      dateFilter: complainDate,
    }
    let header = this.columnDefs.map(column => column.headerName);
    // console.log(header);
    this.excelService.generateExcel(this.excelExportData, fileData, header); 
  }  
  
  arrangeDataForExport(records) {
    let data: any = [];
    let keys = this.columnDefs.map(column => column.field);
    _.each(records, (r)=> { 
      let d = [];
      _.each(keys, (k) => {
        d.push(r[k])
      }) 
      data.push(d);
    })
    // console.log(data);
    this.excelExportData = data;
  }
 
}
